var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.socketRoom)?_c('Map',{attrs:{"socket-room":_vm.socketRoom,"group-id":_vm.groupId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }